import React from "react";
import { Circle } from "@networkraildigitalfactory/components";
import { ChatText } from "phosphor-react";
import styles from "./MultiHeadingAlert.module.css";

const MultiHeadingAlert = (props) => {
  const { content } = props;
  return (
    <div className={styles.multi_heading_alert}>
      {content.map((individual, groupIndex) => {
        const { heading, message } = individual;
        let formattedMessage = message;
        if (message?.includes("\n") && typeof message === "string") {
          formattedMessage = message.split("\n");
        }
        return (
          <div
            key={groupIndex}
            className={`${styles.icon_text_group} ${
              heading !== content[0].heading ? styles.margin : ""
            }`}
          >
            <Circle color="#37519d" size={24}>
              <ChatText color="#f2faff" size={16} className={styles.icon} />
            </Circle>
            <div className={styles.text}>
              <h3>{heading}</h3>
              {typeof formattedMessage === "string" ? (
                <span>{formattedMessage}</span>
              ) : (
                formattedMessage.map((line, lineIndex) => {
                  return (
                    <p key={lineIndex} style={{ marginBottom: "1em" }}>
                      {line}
                    </p>
                  );
                })
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MultiHeadingAlert;
